'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n      &.is-expanded {\n        max-height: ', 'px;\n      }\n    '], ['\n      &.is-expanded {\n        max-height: ', 'px;\n      }\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
var _reactEmotion = require('react-emotion');
var _NavItem = require('./NavItem');
var _NavItem2 = _interopRequireDefault(_NavItem);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Nav = function (_React$Component) {
  _inherits(Nav, _React$Component);
  function Nav() {
    _classCallCheck(this, Nav);
    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
  }
  _createClass(Nav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setExpandedHeight(this.nav);
    }
  }, {
    key: 'setExpandedHeight',
    value: function setExpandedHeight(nav) {
      this.expandedClass = (0, _reactEmotion.css)(_templateObject, nav.clientHeight * this.props.links.length);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var links = this.props.links.map(function (link) {
        return _react2.default.createElement(_NavItem2.default, {
          link: link,
          key: 'nav-item-' + _shortid2.default.generate(),
          className: link.className
        });
      });
      return _react2.default.createElement('nav', {
        className: 'nav ' + this.props.className,
        ref: function ref(nav) {
          _this2.nav = nav;
        }
      }, _react2.default.createElement('ul', {
        className: 'nav__list ' + this.expandedClass + ' ' + (this.props.expanded ? 'is-expanded' : '')
      }, links, this.props.children));
    }
  }]);
  return Nav;
}(_react2.default.Component);
Nav.defaultProps = {
  children: null,
  className: '',
  expanded: false
};
Nav.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  expanded: _propTypes2.default.bool,
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    className: _propTypes2.default.string,
    image: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string
  })).isRequired
};
exports.default = Nav;